import axios from 'axios'
import mixin from '../mixins'

const props = mixin.props.props.default()

function url (key) { // 默认url指定
    return `/api/dictionaryItems/${key}/support-negot-items`
    // return `/api/dictionaryItems/${key}/local-items`
}

async function getDictionary (url, key, cacheTimestamp) {
    const { data } = await axios.get(url, { params: { cacheTimestamp } }).catch(error => { console.error(`字典ID：${key}，字典获取异常`,error.response) })
    if (data.status != 'yes') return console.error(`字典ID：${key}，字典获取异常`)
    return data
}

const state = {
    Map: {},
    Dic: {}
}

const mutations = {
    Map (state, { key, map }) {
        state.Map[key] = map
    },
    Dic (state, { key, dic }) {
        state.Dic[key] = dic
    }
}

const actions = {
    async getDictionaryByKey (content, params) {
        let key = ''
        if (typeof params === 'string') key = params
        else if (Object.prototype.toString.call(params) === '[object Object]') key = params.key
        if (params.url) key = params.url
        let map = {}
        let dic = []
        content.commit('Dic', { key, dic })
        content.commit('Map', { key, map })
        if (!params.reload && mixin.methods.hasLocalDic(key)) {
            const storage = mixin.methods.getLocalStorage(key)
            if (params.cacheUpdate) { // 协商缓存情况，需每次请求接口，查看是否到期
                const data = await getDictionary(params.url || url(key), key, storage.cacheTimestamp)
                if (data.data.length > 0) {
                    dic.push(...(data.data))
                    dic.forEach(item => { map[item[props.key]] = item[props.value] })
                    mixin.methods.setLocalStorage(data.data, key || params.url, map)
                } else {
                    dic.push(...(storage.dir || []))
                    map = storage.map
                }
            } else {
                dic.push(...(storage.dir || []))
                map = storage.map
            }
        } else {
            const data = await getDictionary(params.url || url(key), key)
            dic.push(...(data.data || []))
            dic.forEach(item => { map[item[props.key]] = item[props.value] })
            mixin.methods.setLocalStorage(data.data, key || params.url, map)
        }
        content.commit('Dic', { key, dic })
        content.commit('Map', { key, map })
        return { dic }
    }
}

// 模块方式注册
export const JDictionary = {
    namespaced: true,
    state,
    mutations,
    actions
}
